/* Italian Language File */

var currentlanguage = 'it';

+function ($) {

	/* Italian translation for the jQuery dataTable Addon */
	if ('undefined' !== typeof $.fn.dataTable) {
		$.extend( true, $.fn.dataTable.defaults, {
			"oLanguage": {
				"sEmptyTable":     "Nessun dato presente nella tabella",
				"sInfo":           "Vista da _START_ a _END_ di _TOTAL_ elementi",
				"sInfoEmpty":      "Vista da 0 a 0 di 0 elementi",
				"sInfoFiltered":   "(filtrati da _MAX_ elementi totali)",
				"sInfoPostFix":    "",
				"sInfoThousands":  ",",
				"sLengthMenu":     "Visualizza _MENU_ elementi",
				"sLoadingRecords": "Caricamento...",
				"sProcessing":     "Elaborazione...",
				"sSearch":         "Cerca:",
				"sZeroRecords":    "La ricerca non ha portato alcun risultato.",
				"oPaginate": {
				    "sFirst":      "Inizio",
				    "sPrevious":   "Precedente",
				    "sNext":       "Successivo",
				    "sLast":       "Fine"
				},
				"oAria": {
				    "sSortAscending":  ": attiva per ordinare la colonna in ordine crescente",
				    "sSortDescending": ": attiva per ordinare la colonna in ordine decrescente"
				}
			}
		});
	}

	// Extra APT validator translations
	if ('undefined' !== typeof $.validator) $.extend($.validator.messages, {
		// Extra for apt
		credit_limit: "The credit limit should be between 250k and 150M.",
		grace_holiday_period: "The grace period should be lower than the term in months.",
		term_grace_leasing: "The term minus grace period should always be a multiple of payment frequency.",
		max_term_leasing: "The term minus grace period should not exceed 240 months (20 years).",
		max_term_factoring: "The term should not exceed 1200 months (100 years).",
		net_principal_amount: "The sum of down payment and residual value should be lower than the net principle amount.",
		zero: "This field must be greater than zero."
	});

}(jQuery);
